import styled, { css } from "styled-components"

export const FilterContentSection = styled.div<{ $scrollable?: boolean; $maxHeight?: number }>`
  padding: 8px 16px 16px;

  ${({ $scrollable, $maxHeight }) =>
    $scrollable &&
    css`
      max-height: ${$maxHeight || 300}px;
      overflow-y: auto;
    `};
`
